import { lazy, Suspense } from 'react';
import { LoadingSpinner } from '@shared/components';

// Lazy load pages for code splitting
const HomePage = lazy(() => import('@features/home/pages/HomePage'));
const ProductsPage = lazy(
  () => import('@features/products/pages/ProductsPage')
);
const ProductDetailPage = lazy(
  () => import('@features/products/pages/ProductDetailPage')
);
const CartCheckoutPage = lazy(
  () => import('@features/cart/pages/CartCheckoutPage')
);
const AccountPage = lazy(() => import('@features/account/pages/AccountPage'));
const CategoriesPage = lazy(
  () => import('@features/categories/pages/CategoriesPage')
);
const LoginPage = lazy(() => import('@features/auth/pages/LoginPage'));
const SignupPage = lazy(() => import('@features/auth/pages/SignupPage'));
const ContactPage = lazy(() => import('@features/static/pages/ContactPage'));
const FAQPage = lazy(() => import('@features/static/pages/FAQPage'));
const ShippingPage = lazy(() => import('@features/static/pages/ShippingPage'));
const ReturnsPage = lazy(() => import('@features/static/pages/ReturnsPage'));
const PrivacyPage = lazy(() => import('@features/static/pages/PrivacyPage'));
const WishlistPage = lazy(
  () => import('@features/wishlist/pages/WishlistPage')
);
const ReelsPage = lazy(() => import('@features/reels/pages/ReelsPage'));

export interface RouteConfig {
  path: string;
  element: React.ReactElement;
  label?: string;
}

export const routes: RouteConfig[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <HomePage />
      </Suspense>
    ),
    label: 'Home',
  },
  {
    path: '/products',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <ProductsPage />
      </Suspense>
    ),
    label: 'Products',
  },
  {
    path: '/products/:id',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <ProductDetailPage />
      </Suspense>
    ),
  },
  {
    path: '/cart',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <CartCheckoutPage />
      </Suspense>
    ),
    label: 'Cart',
  },
  {
    path: '/wishlist',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <WishlistPage />
      </Suspense>
    ),
    label: 'Wishlist',
  },
  {
    path: '/account',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AccountPage />
      </Suspense>
    ),
    label: 'Account',
  },
  {
    path: '/orders',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AccountPage />
      </Suspense>
    ),
    label: 'My Orders',
  },
  {
    path: '/categories',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <CategoriesPage />
      </Suspense>
    ),
    label: 'Categories',
  },
  {
    path: '/categories/:categoryId',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <CategoriesPage />
      </Suspense>
    ),
  },
  {
    path: '/login',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <LoginPage />
      </Suspense>
    ),
    label: 'Login',
  },
  {
    path: '/signup',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <SignupPage />
      </Suspense>
    ),
    label: 'Sign Up',
  },
  {
    path: '/contact',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <ContactPage />
      </Suspense>
    ),
  },
  {
    path: '/faq',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <FAQPage />
      </Suspense>
    ),
  },
  {
    path: '/shipping',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <ShippingPage />
      </Suspense>
    ),
  },
  {
    path: '/returns',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <ReturnsPage />
      </Suspense>
    ),
  },
  {
    path: '/privacy',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <PrivacyPage />
      </Suspense>
    ),
  },
  {
    path: '/reels',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <ReelsPage />
      </Suspense>
    ),
    label: 'Reels',
  },
];
